/**
 * @Author: zhengpengcheng
 * @Description:
 * @DateTime: Created in 2022-11-09 14:28:00
 */

 import Api from '../../../../util/api';
 import {PageDo, Result, ResultPageDo } from '../../../../types/base';
 import { defaultNullValue } from 'src/config';
 
 export declare namespace TestDOI {
    export interface RowDataI {
        id: number;
        error_no: string;
        error_info: string;
        operate_datetime: string;
        operator:  string;
    }
 
    export interface QueryRowDataParamsI extends PageDo {
        //关键字
        keyword?: string;
    }

    export interface QueryRowDataParamsIDetail extends PageDo{
        id:number
    }
    
    //添加信息
    export interface FormDataI {
        id?: number;
        error_no: string;
        error_info: string;
    }

    //报错号详情信息
    export interface ErrorNoDetails {
        id: number;
        error_no_id: number;
        file_name: string;
        file_url: string;
        operator: string;
        upload_datetime: string;
    }
    
    //新增报错信息
    export interface AddErrorFile {
        error_no_id: number;
        file_name: string;
        file_url: string;
    }
 }


 export default class TestApi {
    /**
     * 获取报错信息列表
     */
    static async searchList(params: TestDOI.QueryRowDataParamsI): Promise<ResultPageDo<TestDOI.RowDataI[]>> {
        return Api.post('/ops/error_info/list/get', {
            keyword: '',
            ...params,
        });
    }
    

    /**
     * 新增报错信息
     */
    static async add(data:TestDOI.FormDataI):Promise<Result<any>> {
		return Api.post('/ops/error_info/add', data)
	}
    
     /**
     * 根据id查询报错信息详情
     */
    static async searchDetail (id: number): Promise<Result<TestDOI.RowDataI[]>> {
		return Api.post('/ops/id/by/detail', {id})
	}
    
     /**
     * 根据id修改报错信息详情
     */
    static async update(data:TestDOI.FormDataI):Promise<Result<any>> {
		return Api.post('/ops/id/by/detail/update', data)
	}


    /**
     * 删除报错信息 
     */
    static async delete(data: { id: number }): Promise<Result<any>> {
        return Api.post('/ops/error_info/delete', data);
    }

    
    /**
     * 根据id查看报错号详情
     */
    static async id_by_details(data:TestDOI.QueryRowDataParamsIDetail):Promise<ResultPageDo<TestDOI.ErrorNoDetails[]>> {
        return Api.post('/ops/error_info_by_id/get', data);
    }
    
    /**
     * 新增报错信息文件
     */
    static async add_error_file(data:TestDOI.AddErrorFile):Promise<Result<any>>{
        return Api.post('/ops/error_info_file/add', data)
    }
    
    /**
     * 删除报错信息文件
     */
    static async delete_error_file(data: { id: number }):Promise<Result<any>>{
        return Api.post('/ops/error_info_file/delete', data)
    }
 }
 